import React, { FC, useState } from 'react'
import classNamesBind from 'classnames/bind'
import Image from 'next/image'

import Modal from '@dashboard/components/Modal'
import Card from '@dashboard/components/Card'

import css from './styles.module.scss'
const classNames = classNamesBind.bind(css)

interface OwnProps {
  img: string
  noMargin?: boolean
  previewText?: string
  subtitle: string
  title: string
  width: number
  height: number
  hideInPreview?: boolean
}
const HoverTile: FC<OwnProps> = ({
  img,
  width,
  height,
  noMargin,
  previewText,
  hideInPreview,
  title,
  subtitle,
}: OwnProps) => {
  const [modalOpen, setModalOpen] = useState(false)
  const imgStyles: React.CSSProperties = { width: `${width || 120}px` }
  if (height) imgStyles.height = `${height}px`

  // Functions
  const toggleModal = () => {
    setModalOpen(!modalOpen)
  }

  // Partials
  const renderTitle = () => {
    const text = previewText ? previewText : title

    if (hideInPreview) return null

    return (
      <div>
        <div className={css.title} dangerouslySetInnerHTML={{ __html: text }} />
      </div>
    )
  }

  const renderModal = () => {
    return (
      <Modal toggleModal={() => toggleModal()} modalOpen={modalOpen}>
        <Card plain title={title.replace('</br>', ' ')}>
          <p>{subtitle}</p>
          <div className={css.modalWrapper}>
            <img className={css.modalImg} src={img} />
          </div>
        </Card>
      </Modal>
    )
  }

  return (
    <div>
      <div
        className={classNames('container', { noMargin })}
        style={{ maxWidth: `${width || 120}px` }}
        onClick={() => toggleModal()}
      >
        <Image
          className={css.img}
          style={imgStyles}
          src={img}
          width={width}
          height={height}
          alt={previewText || 'CTA'}
        />

        {renderTitle()}
      </div>
      {renderModal()}
    </div>
  )
}

export default HoverTile
